export const politiqueConfidentialiteContent = {
  title: "Politique de confidentialité",
  updatedAt: "Dernière mise à jour : septembre 2026",
  sections: [
    {
      heading: "Introduction",
      paragraphs: [
        "La présente politique décrit la manière dont Proximité Confiance Finistère collecte, utilise et protège les informations que vous nous transmettez lors de l'utilisation de ce site.",
      ],
    },
    {
      heading: "Données collectées",
      paragraphs: [
        "Nous collectons uniquement les informations que vous nous communiquez volontairement via le formulaire de contact : votre nom, votre adresse e-mail et votre message.",
      ],
    },
    {
      heading: "Utilisation des données",
      paragraphs: [
        "Ces données sont utilisées exclusivement pour répondre à vos demandes et assurer le suivi de nos échanges. Elles ne sont en aucun cas transmises à des tiers à des fins commerciales.",
      ],
    },
    {
      heading: "Conservation des données",
      paragraphs: [
        "Vos données sont conservées pendant la durée nécessaire au traitement de votre demande, puis supprimées de manière sécurisée.",
      ],
    },
    {
      heading: "Vos droits",
      paragraphs: [
        "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition sur vos données personnelles.",
        "Pour exercer ces droits, contactez-nous à l'adresse contact@proximiteconfiancefinistere.fr.",
      ],
    },
    {
      heading: "Cookies",
      paragraphs: [
        "Ce site n'utilise pas de cookies à des fins publicitaires. Seuls des cookies techniques, strictement nécessaires au fonctionnement du site, peuvent être déposés.",
      ],
    },
    {
      heading: "Contact",
      paragraphs: [
        "Pour toute question relative à cette politique de confidentialité, vous pouvez nous écrire à contact@proximiteconfiancefinistere.fr ou appeler le 06 77 45 38 37.",
      ],
    },
  ],
};